// Modules
import React from 'react';
import {connect} from 'react-redux';
import PlayerTeeScore from './playerTeeScore';

export function singleTeeInput(props){
    const playerHtml = Object.keys(props.roster).map((keyName, index) =>{
        return <PlayerTeeScore
            gamertag={keyName}
            teeNum={props.teeNum}
            teeScore={props.roster[keyName][props.teeNum-1]}
            key={index}
            socket={props.socket}
        />
    });

    // Listen for ser-roster emit?

    return(
        <details>
            <summary>Tee {props.teeNum}</summary>
            {playerHtml}
        </details>
    );
}

// Props Mapping
const mapPropToState = state => ({
    roster: state.match.roster
});
export default connect(mapPropToState)(singleTeeInput);


// WEBPACK FOOTER //
// ./src/comps/singleTee.js